export default {
  namespaced: true,
  helpdesk: {
    title: "Helpdesk",
    agent:{
      title: "Agent",
      first_name: "First Name",
      last_name: "Last Name",
      email: "Email",
      is_active: "Is Active",
    },
    group:{
      title: "Group",
      name: "Name",
      description: "Description",
      is_active: "Is Active",
    },
    ticket:{
      title: "Ticket|Tickets",
      create_ticket: "Create ticket",
      created_at: "Created At",
      name: "Name",
      from: "From",
      subject: "Subject",
      message: "Message",
      description: "Description",
      priority: "Priority",
      status: "Status",
      attachments: "Attach a file",
      update: "Update",
      cc: "CC",
      for: "For",
      owner: 'Owner',
      type: 'Type',
      ticket_type: 'Ticket types',
    }
  }
};
